import * as React from 'react';
import { styled } from '../theme-provider';
export const StyledTableBody = styled.tbody.withConfig({ displayName: "StyledTableBody", componentId: "sc-1vuj8ed" }) `border:inherit;`;
export const TableBody = ({ children }) => {
    return React.createElement(StyledTableBody, null, children);
};
